/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import { diff } from 'deep-diff';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { isNumber } from './formUtilities';

const stringifyPath = (path) => {
  let str = '';
  path.forEach((p) => {
    if (isNumber(p)) {
      str = `${str}[${p}]`;
    } else if (str) {
      str = `${str}.${p}`;
    } else {
      str = p;
    }
  });
  return str;
};

// eslint-disable-next-line react/prop-types
const renderNew = ({ path, rhs }) => {
  const strPath = stringifyPath(path);
  return (
    <div key={strPath} className="haz-diff-new">
      <div className="haz-diff-path">{`Added ${strPath}`}</div>
      <div className="haz-diff-value">{`+ '${rhs}'`}</div>
    </div>
  );
};
// eslint-disable-next-line react/prop-types
const renderDeleted = ({ path, lhs }) => {
  const strPath = stringifyPath(path);
  return (
    <div key={strPath} className="haz-diff-deleted">
      <div className="haz-diff-path">{`Removed ${strPath}`}</div>
      <div className="haz-diff-value">{`- '${lhs}'`}</div>
    </div>
  );
};
// eslint-disable-next-line react/prop-types
const renderEdited = ({ path, lhs, rhs }) => {
  const strPath = stringifyPath(path);
  return (
    <div key={strPath} className="haz-diff-edited">
      <div className="haz-diff-path">{`Modified ${strPath}`}</div>
      <div className="haz-diff-value">{`'${lhs}' => '${rhs}'`}</div>
    </div>
  );
};

const renderArrayChange = ({ path, index, item }) => {
  const entry = { ...item, path: [...path, index] };
  // eslint-disable-next-line no-use-before-define
  return renderByKind(entry);
};

const renderByKind = (entry) => {
  const { kind } = entry;
  switch (kind) {
    case 'N':
      return renderNew(entry);
    case 'D':
      return renderDeleted(entry);
    case 'E':
      return renderEdited(entry);
    case 'A':
      return renderArrayChange(entry);
    default:
      throw new Error(`Invalid diff kind ${kind}`);
  }
};

const parseDiff = differences => differences.map(renderByKind);

const normalize = map => JSON.parse(JSON.stringify(map.toJS()));

export class EditConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this.focus = this.focus.bind(this);
    this.renderDiff = this.renderDiff.bind(this);
    this.saveCancel = null;
  }

  focus() {
    this.saveCancel.focus();
  }

  renderDiff(differences) {
    const {
      title,
    } = this.props;

    return (
      <div className="haz-diff-container">
        <div className="haz-diff-title">{`Review ${title} Changes`}</div>
        <div className="haz-diff-body">
          {differences ? parseDiff(differences) : null}
        </div>
      </div>
    );
  }

  render() {
    const {
      isOpen, saving, title, onCancel, onSave, existing, updated,
    } = this.props;

    const differences = diff(normalize(existing), normalize(updated));

    return (
      <Modal isOpen={isOpen} onOpened={this.focus} backdrop="static">
        <ModalHeader>{`Save ${title}`}</ModalHeader>
        <ModalBody>
          {saving ? 'Saving...' : this.renderDiff(differences)}
        </ModalBody>
        <ModalFooter>
          <Button disabled={saving} color="primary" onClick={() => onSave({ existing, updated, differences })}>Save</Button>
          {' '}
          <Button disabled={saving} color="secondary" innerRef={(ref) => { this.saveCancel = ref; }} onClick={onCancel}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

EditConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  saving: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  existing: ImmutablePropTypes.map.isRequired,
  updated: ImmutablePropTypes.map.isRequired,
};
